import { ACDLRoute, BaseRouteConfig } from './BaseRoute';

export class AdminPath extends BaseRouteConfig {
  public readonly Index = 'admin';

  public readonly Users = new ACDLRoute<{ workspaceId: string }>(`${this.Path}/users`);

  public readonly Workspaces = new ACDLRoute<{ workspaceId: string }>(`${this.Path}/workspaces`);
}
